<section class="Projects">
  <div class="container-fluid">
    <div class="row heading-row">
      <h2 class="heading">
        <hr />
        Our Products
      </h2>
    </div>
    <div class="row products-row">
      <div class="currentProjects">
        <img src="assets/images/erp.png" class="img-fluid" alt="ERP" />
        <h3>ERP</h3>
        <p class="para">
          A top-tier ERP provider, delivering comprehensive applications for finance, supply chain, manufacturing, and other business functions with global recognition.
        </p>
        <a [routerLink]="['/moreinfo/product-erp']">Learn More</a>
      </div>
      <div class="currentProjects">
        <img src="assets/images/fleet.png" class="img-fluid" alt="Fleet Management" />
        <h3>Fleet Management</h3>
        <p class="para">
          ERP streamlines fleet management by efficiently tracking and managing vehicles, optimizing routes, scheduling maintenance, and ensuring regulatory compliance.
        </p>
        <a [routerLink]="['/moreinfo/product-fleet-management']">Learn More</a>
      </div>
      <div class="currentProjects">
        <img src="assets/images/mobile_app.png" class="img-fluid" alt="Mobile App" />
        <h3>Mobile App</h3>
        <p class="para">
          The app enables remote shopping and manages warranties effortlessly, enhancing convenience by digitalizing warranty and guarantee management within the platform.
        </p>
        <a [routerLink]="['/moreinfo/product-mobile-management']">Learn More</a>
      </div>
      <div class="currentProjects">
        <img src="assets/images/mobile_app.png" class="img-fluid" alt="Mobile App" />
        <h3>Unified Ai Powered Dashboard</h3>
        <p class="para">
          Our platform provides telecom operators with a unified customer experience portal that consolidates SD-WAN, MPLS, broadband, and IoT/M2M services into a single real-time dashboard.
        </p>
        <a [routerLink]="['/moreinfo/ai-powered-dashboard']">Learn More</a>
      </div>
    </div>
  </div>
</section>
